// Rename ArticleListName to the name of the feature you are creating.

export const RenameArticleList = async () => {
    // Find all elements with data-mrf-recirculation attribute
    const elementsWithMrf: NodeListOf<HTMLElement> = document.querySelectorAll(
        '[data-mrf-recirculation]',
    );

    // Group elements by their attribute values
    const valueGroups = new Map<string, HTMLElement[]>();

    elementsWithMrf.forEach((element) => {
        const value = element.getAttribute('data-mrf-recirculation');
        if (value) {
            if (!valueGroups.has(value)) {
                valueGroups.set(value, []);
            }
            valueGroups.get(value)!.push(element);
        }
    });

    // Process each group independently
    valueGroups.forEach((elements, originalValue) => {
        elements.forEach((element, index) => {
            // First item gets no suffix, subsequent items get numbered suffix
            const newValue = index === 0 ? originalValue : `${originalValue} ${index + 1}`;
            element.setAttribute('data-mrf-recirculation', newValue);
        });
    });
};
